import { Head, router } from "@inertiajs/react"
import { Welcome } from "@/components/VocationalTest/Welcome"

export default function WelcomePage() {
  return (
    <>
      <Head title="Boas-vindas" />
      <Welcome onStart={() => router.visit("/about-test")} />
    </>
  )
}
